import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  container: {
    padding: tokens.spacingHorizontalS,
    height: '100%',
    boxSizing: 'border-box',
    backgroundColor: tokens.colorNeutralBackground1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    scrollbarGutter: 'stable',
  },
  tabsContainer: {
    overflowX: 'auto',
    flexShrink: 0,
  },
  addButton: {
    color: tokens.colorBrandForeground1,
    minWidth: 0,
  },
  tabList: {
    gap: tokens.spacingHorizontalS,
  },
  tabContent: {
    padding: `${tokens.spacingVerticalL} 0`,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  spinner: {
    margin: 'auto',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalL,
    flex: 1,
  },
  errorIconAndMessage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalS,
  },
  hiddenInput: {
    display: 'none',
  },
})

export { useStyles }
